import KindDot from '@/components/sections/updates/KindDot'
import { KINDS, releaseId } from '@/components/sections/updates/releases'
import { useData } from '@/hooks/useLocale'

/**
 * One release: its version, date and title, a summary, then its changes
 * grouped by the `kinds` being shown (new, improved, fixed).
 */
export default function ReleaseNote({ release, latest, kinds }) {
  const { UPDATES } = useData()

  return (
    <article
      id={releaseId(release.version)}
      className="mb-11 flex flex-col gap-[22px] border-b border-line pb-11"
    >
      <div className="flex flex-col gap-2.5">
        <div className="flex flex-wrap items-center gap-2.5">
          <span
            dir="ltr"
            className="flex h-7 items-center rounded-[14px] bg-ink px-3 text-[13px] font-bold text-white"
          >
            {release.version}
          </span>
          <span className="text-sm text-subtle">{release.date}</span>
          {latest && (
            <span className="flex h-6 items-center rounded-xl bg-[#e7f6ec] px-2.5 text-xs font-semibold text-[#1a7f46]">
              {UPDATES.latest}
            </span>
          )}
        </div>
        <h2 className="text-[clamp(26px,2.8vw,34px)] leading-[1.15] font-medium tracking-[-0.025em] text-ink">
          {release.title}
        </h2>
        <p className="text-[17px]/[1.7] text-muted">{release.summary}</p>
      </div>

      {kinds.map((kind) => (
        <div key={kind} className="flex flex-col gap-3">
          <h3
            className={`flex items-center gap-2 text-xs font-bold tracking-[.14em] uppercase ${KINDS[kind].text}`}
          >
            <KindDot kind={kind} />
            {UPDATES.kinds[kind]}
          </h3>
          <ul className="flex flex-col overflow-hidden rounded-[18px] inset-ring inset-ring-line">
            {release[kind].map((change) => (
              <li
                key={change.title}
                className="flex flex-col gap-1 border-t border-[#f0f2f6] px-5 py-4 first:border-t-0"
              >
                <span className="text-base font-semibold text-ink">
                  {change.title}
                </span>
                <span className="text-[15px]/[1.6] text-muted">{change.text}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </article>
  )
}
